import React from 'react';
import styles from './BottomNav.module.css';

function BottomNav({
  visible = true,
  menuItems = [],
  activeKey,
  onMenuClick
}) {
  if (!visible) return null;

  const renderBadge = (badge) => {
    if (!badge) return null;

    // true: 只显示小红点
    if (badge === true) {
      return <span className={`${styles.badge} ${styles.dotBadge}`} />;
    }

    return <span className={styles.badge}>{badge}</span>;
  };

  return (
    <div className={styles.bottomNav}>
      {menuItems.map(item => (
        <div
          key={item.key}
          className={`${styles.bottomNavItem} ${activeKey === item.key ? styles.active : ''}`}
          onClick={() => onMenuClick?.(item)}
        >
          <span className={styles.bottomNavIconWrapper}>
            <span className={styles.bottomNavIcon}>
              {item.icon?.startsWith('#') ? (
                <svg className={styles.bottomNavSvgIcon} aria-hidden="true">
                  <use xlinkHref={item.icon}></use>
                </svg>
              ) : (
                item.icon || '•'
              )}
            </span>
            {renderBadge(item.badge)}
          </span>

          <div className={styles.bottomNavLabel}>{item.label}</div>
        </div>
      ))}
    </div>
  );
}

export default BottomNav;